import React from 'react';
import { useFieldConfigurationDetails } from '../../../Hooks/Features/TaskLayout/Fields/useFieldConfigurationDetails';
import CommonGrid from '../../CommonCompo/CommonGrid/CommonGrid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MultiSelect } from 'primereact/multiselect';
import PanelHeaderTemplate from '../../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate';
import _ from "underscore"

const FieldConfigurationDetails = ({ filterValues, setFilterValues, fieldValues, setFieldValues, upsertFieldConfig }) => {
    const { columns, fieldData, option, multiSelectRef, loader } = useFieldConfigurationDetails({ filterValues, setFilterValues });

    return (
        <div className="">
            <div className='d-flex gap-4 align-items-center justify-content-between'>
                <div className='d-flex gap-2 align-items-center px-2'>
                    <button className='sk-btn sk-btn-primary' onClick={() => setFilterValues((prev) => ({ ...prev, config: {}, apiCall: true }))}>
                        <FontAwesomeIcon icon="fa-solid fa-angle-left" />
                    </button>
                    <div className='fw-bold' style={{ fontSize: "20px" }}>Field behaviors: {filterValues?.config?.field_configuration_name}</div>
                </div>
                <div className="d-flex align-items-center">
                    <button
                        type="button"
                        className="sk-btn sk-btn-primary bg-black text-white"
                        onClick={(e) => multiSelectRef.current.show(e)}
                    >
                        <FontAwesomeIcon icon="fa-solid fa-plus" /> Add field
                    </button>
                    <div style={{ width: "20px", height: "auto", visibility: 'hidden', overflow: 'hidden' }}>
                        <MultiSelect
                            ref={multiSelectRef}
                            options={option?.fields}
                            optionLabel="custom_field_name"
                            optionValue="custom_field_id"
                            value={fieldValues?.field}
                            onChange={(e) => setFieldValues((prev) => ({ ...prev, field: e.target.value, isChange: true }))}
                            filter
                            onHide={() => {
                                if (fieldValues?.isChange) {
                                    const existingIds = _.pluck(fieldData || [], "custom_field_id");
                                    const selectedIds = fieldValues?.field || [];
                                    const mergedIds = [...new Set([...existingIds, ...selectedIds])];
                                    upsertFieldConfig(false, mergedIds, true);
                                }
                            }}
                            panelHeaderTemplate={(options) => PanelHeaderTemplate(options, "field", fieldValues?.field, () => setFieldValues((prev) => ({ ...prev, field: [] })))}
                        />
                    </div>
                </div>
            </div>
            <div className="mt-2 w100" style={{ height: "calc(100vh - 160px)", overflow: "auto" }}>
                <CommonGrid columns={columns} data={[{ id: "all", title: "", children: fieldData }]} expandAll={true} rowHeight={35} headerHeight={50} strippedTable={true} loader={loader} />
            </div>
        </div>
    );
};

export default FieldConfigurationDetails;